import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Icon,
  CircularProgress,
} from "@mui/material";

interface LogoutDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const LogoutDialog: React.FC<LogoutDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 400,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          pb: 1,
        }}
      >
        <Icon
          sx={{
            color: "warning.main",
            fontSize: 28,
          }}
        >
          logout
        </Icon>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Sign Out
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to sign out of your account?
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          You will need to sign in again to access the accounting system.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          disabled={isLoading}
          variant="outlined"
          sx={{
            minWidth: 100,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isLoading}
          variant="contained"
          color="error"
          startIcon={
            isLoading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <Icon>logout</Icon>
            )
          }
          sx={{
            minWidth: 100,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {isLoading ? "Signing Out..." : "Sign Out"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
